import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import CountdownTimer from "../components/CountdownTimer";
import axios from "axios";
import { APIURI } from "../config";
import { useHistory, withRouter } from "react-router";
import createMarkup from "../utils/CreateMarkup";
import Video from "../utils/Videos/Video";

const PodStartStory = ({
  podDetails,
  teamInfo,
  isSomeThingUpdated,
  podStatus,
  isTeamCreator,
  hasPodStarted,
  teamPageDesc,
  isCustomBlueTheme,
}) => {
  const [isPodStarted, setIsPodStarted] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);
  const [isTimerEnd, setIsTimerEnd] = useState(false);
  const [hasPodStartedOnPage, sethasPodStartedOnPage] = useState(hasPodStarted);
  const [teamMembers, setTeamMembers] = useState(teamInfo.UserNames);
  const [isScrollable, setIsScrollable] = useState(false);
  const [leaveTeamModal, setLeaveTeamModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [togglePopoverArr, setTooglePopoverArr] = useState([]);
  const [togglePopover, setTooglePopover] = useState(false);
  const [togglePopoverMessage, setTooglePopoverMessage] = useState([]);
  const [countForShowModal, setCountForShowModal] = useState(0);
  const [fontsReady, setFontsReady] = useState(false);
  console.log(isTeamCreator);
  let history = useHistory();
  const themeEnabled = podDetails?.theme_enabled ?? false;
  const theme = podDetails?.theme ?? null;

  const hasFonts = Boolean(
    theme?.fonts?.title || theme?.fonts?.body || theme?.fonts?.button
  );

  // All theme styles in one place — @font-face + utility classes with direct colour values
  const themeCSS = useMemo(() => {
    if (!themeEnabled || !theme || !podDetails?._id) return "";
    const hasTitleFont = Boolean(theme.fonts?.title);
    const hasBodyFont = Boolean(theme.fonts?.body);
    const hasButtonFont = Boolean(theme.fonts?.button);
    const podId = podDetails._id;
    const bg = theme.colors?.background ?? "#ffffff";
    const ui = theme.colors?.ui ?? "#000000";
    const btnBg = theme.colors?.button_background ?? "#000000";
    const btnText = theme.colors?.button_text ?? "#ffffff";
    const accent = theme.colors?.accent ?? "#000000";
    return `
      ${hasTitleFont ? `@font-face { font-family: 'PodFont-title';  src: url('${APIURI}/pods/podFont/${podId}/title')  format('truetype'); font-display: block; }` : ""}
      ${hasBodyFont ? `@font-face { font-family: 'PodFont-body';   src: url('${APIURI}/pods/podFont/${podId}/body')   format('truetype'); font-display: block; }` : ""}
      ${hasButtonFont ? `@font-face { font-family: 'PodFont-button'; src: url('${APIURI}/pods/podFont/${podId}/button') format('truetype'); font-display: block; }` : ""}
      .Solution .header{
        padding-top:10px;
      }
      .pod-theme-page {
      }
      .pod-theme-ui {
        color: ${ui} !important;
      }
      ${
        hasTitleFont
          ? `.pod-theme-title {
        font-family: 'PodFont-title' !important;
      }`
          : ""
      }
      ${
        hasBodyFont
          ? `.pod-theme-body {
        font-family: 'PodFont-body' !important;
      }`
          : ""
      }
      ${
        hasButtonFont
          ? `.pod-start-screen h3.pod-theme-body,
      .pod-start-screen h3.pod-theme-code-badge {
        font-family: 'PodFont-button' !important;
      }`
          : ""
      }
      .pod-theme-btn.MuiButtonBase-root,
      .pod-theme-btn.MuiButtonBase-root:hover,
      .pod-theme-btn.MuiButtonBase-root:focus {
        background-color: ${btnBg} !important;
        color: ${btnText} !important;
        ${hasButtonFont ? "font-family: 'PodFont-button' !important;" : ""}
      }
      .pod-theme-btn.MuiButtonBase-root .MuiButton-label {
        ${hasButtonFont ? "font-family: 'PodFont-button' !important;" : ""}
        color: ${btnText} !important;
        line-height: 1 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-top: 0 !important;
      }
      ${
        hasButtonFont
          ? `.tooltip span {
        font-family: 'PodFont-button' !important;
      }`
          : ""
      }
      .pod-theme-hr {
        border: none !important;
        height: 2px !important;
        background-color: ${btnBg} !important;
      }
      ${
        hasButtonFont
          ? `.pod-start-screen h3{
        font-family: 'PodFont-button' !important;
      }`
          : ""
      }
      .pod-theme-accent-banner {
        background-color: ${accent} !important;
        color: ${ui} !important;
      }
      .pod-theme-code-badge {
        background: ${btnBg} !important;
        color: ${btnText} !important;
        ${hasBodyFont ? "font-family: 'PodFont-body' !important;" : ""}
      }
      .image--capture--modal--close--btn::before,
      .image--capture--modal--close--btn::after {
        background-color: ${btnText} !important;
      }
      ${
        hasButtonFont
          ? `.team--members--div p, .btn-font {
        font-family: 'PodFont-button' !important;
      }`
          : ""
      }
      ${
        hasBodyFont
          ? `#alert-dialog-description p{
        font-family: 'PodFont-body' !important;
      }`
          : ""
      }
       .pod-start-screen .MuiButton-label {
        line-height: 1 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-top: 0 !important;
      }
      .pod-theme-accent-banner {
        line-height: 1.2 !important;
      }
    `;
  }, [themeEnabled, theme, podDetails]);

  // Block render until fonts are ready to prevent FOUT flicker.
  // useLayoutEffect fires before the browser paints, so nothing is shown
  // until document.fonts.ready resolves.
  useLayoutEffect(() => {
    if (!themeEnabled || !theme || !hasFonts) {
      setFontsReady(true);
      return;
    }
    setFontsReady(false);
    document.fonts.ready.then(() => setFontsReady(true));
  }, [themeCSS, hasFonts, themeEnabled, theme]);
  async function handleTooltip() {
    let elements = document.getElementsByClassName("tooltip");
    let arr = await togglePopoverArr;
    let myFunction = function (e, i, acID) {
      e.preventDefault();
      console.log(arr);
      console.log(e, i, arr[0][acID]);
      setTooglePopover(true);
      setTooglePopoverMessage(arr[0][acID]);
    };

    for (let i = 0; i < elements.length; i++) {
      let actionBtn = elements[i];
      let actionBtnId = actionBtn.id.split("-");
      // console.log(actionBtnId[1]);
      actionBtn.addEventListener(
        "mousedown",
        (e) => myFunction(e, i, actionBtnId[1]),
        false,
      );
    }
  }

  const handleClosePopover = () => {
    setTooglePopover(false);
    // window.location.reload();
    // handleTooltip();
  };

  const handleIsTimerEnd = () => {
    if (!isTimerEnd) {
      setIsTimerEnd(true);
    }
  };

  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      axios
        .get(`${APIURI}/web-teams/getAllTeam/${teamInfo.data._id}`, config)
        .then((res) => {
          console.log(res);
          setTeamMembers(res.data.UserNames);
          sethasPodStartedOnPage(res.data.data.hasStarted);
          if (res.data.data.hasStarted) {
            if (countForShowModal === 0) {
              setIsPodStarted(true);
            }
          }
        });
    };

    // Set up the interval to call the API every 10 seconds
    const interval = setInterval(() => {
      fetchData();
    }, 7000); // 10000 milliseconds = 10 seconds

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(interval);
    };
  }, [countForShowModal]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accessToken = localStorage.getItem("accesstoken");
  let config;
  config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  const handleStartPod = () => {
    setBtnLoad(true);
    axios
      .get(`${APIURI}/web-pods/startPod/${teamInfo.data._id}`, config)
      .then((res) => {
        setBtnLoad(false);
        console.log(res);
        setIsPodStarted(true);
        sethasPodStartedOnPage(true);

        window.location.href = podDetails.scene_id
          ? `/solution:${podDetails.game_id}/${podDetails.scene_id}`
          : `/location:${podDetails.game_id}`;
      })
      .catch((err) => {
        setBtnLoad(false);
        console.log(err);
      });
  };

  const handleContinuePod = () => {
    window.location.href = podDetails.scene_id
      ? `/solution:${podDetails.game_id}/${podDetails.scene_id}`
      : `/location:${podDetails.game_id}`;
  };

  const handleLeaveTeam = () => {
    axios
      .get(`${APIURI}/web-teams/leaveTeam/${teamInfo.data._id}`, config)
      .then((res) => {
        console.log(res);
        isSomeThingUpdated();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePopUps = (data) => {
    let desc = data;
    if (podDetails && podDetails.Pod_popup) {
      let arrPop = togglePopoverArr;
      arrPop.push(podDetails.Pod_popup.map((te) => te.description));
      console.log(arrPop);
      setTooglePopoverArr(arrPop);
    }
    if (podDetails && podDetails.Pod_popup) {
      podDetails.Pod_popup.map((te, i) => {
        if (te.icon) {
          desc = desc.replaceAll(
            te.identifier,
            `<span class="tooltip" id='tooltip-${i}'><img src="${te.icon}" alt="PopupIcon" /><span>${te.title}</span></span>`,
          );
        } else {
          desc = desc.replaceAll(
            te.identifier,
            `<span class="tooltip" id='tooltip-${i}'><img src ="/assets/PopupIcon.svg" alt="PopupIcon" /><span>${te.title}</span></span>`,
          );
        }
        handleTooltip();
      });
    }
    return (
      <div
        // className="sol-screen"
        className="desc-Text-solution"
        dangerouslySetInnerHTML={createMarkup(desc)}
      />
    );
  };
  const popupMemo = useMemo(() => handlePopUps(teamPageDesc), []);

  if (themeEnabled && theme && !fontsReady) {
    return null;
  }

  return (
    <>
      <style>{themeCSS}</style>
      <div
        className={`Solution pod-start-screen${themeEnabled && theme ? " pod-theme-page" : ""}`}
        style={themeEnabled && theme ? { minHeight: "100vh" } : {}}
      >
        <div className="header">
          <h2
            className={`solutionTitle${themeEnabled && theme ? " pod-theme-title" : ""}`}
          >
            {podDetails && podDetails.title}
          </h2>
        </div>
        <hr className={themeEnabled && theme ? "pod-theme-hr" : ""} />
        <div className="container-sol">
          <div className="container-code">
            {!podDetails?.activateTeamViaQR && (
              <h3
                className={`code--to--join${themeEnabled && theme ? " pod-theme-code-badge btn-font" : ""}`}
              >
                CODE TO JOIN:{teamInfo.data.teamCode}
              </h3>
            )}
            <div>
              <h3
                style={{ textAlign: "center" }}
                className={themeEnabled && theme ? "pod-theme-body" : ""}
              >
                {teamInfo.data.teamName.toUpperCase()}
              </h3>
              {!podDetails?.activateTeamViaQR && (
                <div
                  className={`team--members--div${themeEnabled && theme ? " pod-theme-body" : ""}`}
                >
                  {teamMembers.map((res) => (
                    <p key={res} style={{ textAlign: "center" }}>
                      {res}
                    </p>
                  ))}
                </div>
              )}
              {podDetails?.startScreenMedia?.url && (
                <div className="media-container" style={{ marginLeft: 0, marginRight: 0 }}>
                  {podDetails.startScreenMedia.mediaType === "video" ? (
                    <Video content={podDetails.startScreenMedia.url} />
                  ) : (
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={podDetails.startScreenMedia.url}
                      alt="Pod start screen"
                    />
                  )}
                </div>
              )}
              <div
                className={
                  themeEnabled && theme ? "pod-theme-body pod-theme-ui" : ""
                }
              >
                {popupMemo}
              </div>
            </div>
          </div>
        </div>
        <div className="start--section--fixed">
          <h3
            className={themeEnabled && theme ? "pod-theme-accent-banner" : ""}
            style={{
              margin: "0",
              padding: "0.6em 0",

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",

              textAlign: "center",
              width: "100%",

              lineHeight: "1.2",

              ...(themeEnabled && theme
                ? {}
                : {
                  backgroundColor: "#fffb00",
                  color: "#000",
                }),
            }}
          >
            {!isTimerEnd ? (
              <>
                YOUR ADVENTURE <br /> BEGINS IN: <br />
                <span style={{ fontWeight: "bolder" }}>
                  {" "}
                  <CountdownTimer
                    targetDate={podDetails.fromDate}
                    handleIsTimerEnd={handleIsTimerEnd}
                  />
                </span>
              </>
            ) : hasPodStartedOnPage ? (
              <>
                {" "}
                YOUR CLOCK HAS STARTED. <br /> CLICK CONTINUE TO PLAY!{" "}
              </>
            ) : (
              <>
                {" "}
                CLICK START TO PLAY <br />{" "}
              </>
            )}
          </h3>
          <div className="container-sol">
            <div className="container-code">
              {hasPodStartedOnPage ? (
                <Button
                  className={`submit--btn margin--0${themeEnabled && theme ? " pod-theme-btn" : ""}`}
                  variant="contained"
                  onClick={() => handleContinuePod()}
                >
                  CONTINUE
                </Button>
              ) : (
                <Button
                  className={`submit--btn margin--0${themeEnabled && theme ? " pod-theme-btn" : ""}`}
                  variant="contained"
                  disabled={(podStatus !== "active" && !isTimerEnd) || btnLoad}
                  style={{
                    opacity: `${(podStatus === "active" || isTimerEnd) && !btnLoad ? "1" : "0.6"}`,
                  }}
                  onClick={() => handleStartPod()}
                >
                  START
                </Button>
              )}

              {!podDetails?.activateTeamViaQR && (
                <Button
                  className={`dialog-btn-dismiss--transparent dialog-btn-dismiss margin--top--1rem${themeEnabled && theme ? " btn-font" : ""}`}
                  autoFocus
                  variant="contained"
                  style={{ width: "100%" }}
                  onClick={() => {
                    if (isTeamCreator) {
                      setLeaveTeamModal(true);
                    } else {
                      handleLeaveTeam();
                    }
                  }}
                >
                  LEAVE TEAM
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* PodStarted modal  */}
      <Dialog
        open={false} // if you want to show this modal, set isPodStarted
        onClose={() => {
          setIsPodStarted(false);
          setCountForShowModal(countForShowModal + 1);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="PopOver"
      >
        {/* <DialogTitle id="alert-dialog-title">Message</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* <div dangerouslySetInnerHTML={createMarkup(pushNotificationData)} /> */}
            <div>
              <p>Your time has started! Scan any game QR code to begin play.</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsPodStarted(false);
              setCountForShowModal(countForShowModal + 1);
            }}
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{ marginBottom: "2.2rem" }}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      {/* leave team modal for creator  */}
      <Dialog
        open={leaveTeamModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="access--code--modal create--join--team--modals"
      >
        <DialogTitle id="alert-dialog-title" className="access--code--required">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span className={themeEnabled && theme ? "pod-theme-title" : ""}>
              {"Leave Team?"}
            </span>
            <Button
              className={`image--capture--modal--close--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
              autoFocus
              variant="contained"
              onClick={() => {
                setErrorMessage("");
                setLeaveTeamModal(false);
              }}
            ></Button>
          </div>
        </DialogTitle>
        <DialogContent
          className={themeEnabled && theme ? "pod-theme-body" : ""}
        >
          Are you sure you want to leave this team?
        </DialogContent>
        <DialogActions
          style={{
            padding: "16px 24px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{
              width: "100%",
              ...(themeEnabled && theme ? {} : { color: "#fffb00" }),
            }}
            onClick={() => handleLeaveTeam()}
          >
            LEAVE TEAM
          </Button>
          <Button
            className={`dialog-btn-dismiss leave--team--modal--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{
              width: "100%",
              ...(themeEnabled && theme ? {} : { color: "#fffb00" }),
            }}
            onClick={() => setLeaveTeamModal(false)}
          >
            STAY IN TEAM
          </Button>
        </DialogActions>
      </Dialog>

      {/* popup modal  */}
      <Dialog
        open={togglePopover}
        onClose={handleClosePopover}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="PopOver"
      >
        {/* <DialogTitle id="alert-dialog-title">Message</DialogTitle> */}
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={themeEnabled && theme ? "pod-theme-body" : ""}
          >
            <div dangerouslySetInnerHTML={createMarkup(togglePopoverMessage)} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClosePopover}
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{ marginBottom: "2.2rem" }}
          >
            Okay
          </Button>
          {/* <Camera onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }/> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PodStartStory;
